// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__YvaSZ","inner":"Footer_inner__eP20F","firstInner":"Footer_firstInner__z3dRC","title":"Footer_title__6qSZp","subTitle":"Footer_subTitle__CqXSg"};